import ApiClient from "./ApiClient";

export const fetchAppConfig = ({ token, rates_version_per_insurer }) => {
  return ApiClient.post('/api/app_config',
    {
      rates_version_per_insurer
    }, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
}